// extracted by mini-css-extract-plugin
module.exports = {"Investors":"Investors_Investors__0pWxq","ContainerTeam":"Investors_ContainerTeam__tSGRR","Header":"Investors_Header__QbSJV","Logos":"Investors_Logos__FWzuw"};